import { all } from "redux-saga/effects";
import { dongBoHocPhiSaga } from "./dongBoHocPhiSaga";
import { dongBoPhiKyTucXaSaga } from "./dongBoPhiKyTucXaSaga";
import { dongBoCongNoSaga } from "./dongBoCongNoSaga";
import { gachNoThuCongSaga } from "./gachNoThuCongSaga";

export default function* dongBoSagaWrapper() {
  yield all([
    dongBoHocPhiSaga(),
    dongBoPhiKyTucXaSaga(),
    dongBoCongNoSaga(),
    gachNoThuCongSaga(),
  ]);
}
